import type { LeaveRequest } from "@spork/s4p-server-sdk";
import { View } from "react-native";

import { Text } from "@/components/ui/text";
import { LeaveRequestListItem } from "./LeaveRequestListItem";

type RequestListProps = {
    requests: LeaveRequest[];
    childrenById: Map<number, string>;
    showChildLabels: boolean;
    emptyLabel?: string;
};

export function RequestList({
    requests,
    childrenById,
    showChildLabels,
    emptyLabel,
}: RequestListProps) {
    if (requests.length === 0) {
        return (
            <Text variant="muted" className="p-3">
                {emptyLabel}
            </Text>
        );
    }

    return (
        <View className="px-3">
            {requests.map((request, index) => (
                <LeaveRequestListItem
                    key={request.id}
                    request={request}
                    isLast={index === requests.length - 1}
                    childLabel={
                        showChildLabels
                            ? childrenById.get(request.child_id)
                            : undefined
                    }
                />
            ))}
        </View>
    );
}
